var render, staticRenderFns
import script from "./Lights.vue?vue&type=script&lang=js&"
export * from "./Lights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Lights.vue"
export default component.exports